tree-with-table.component.html
<!--mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-nested-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    {{ node.name }}
  </mat-nested-tree-node>

  <mat-nested-tree-node *matTreeNodeDef="let node; when: isLeaf" matTreeNodeToggle>
    <strong>{{ node.name }}</strong>
    <table mat-table [dataSource]="node.tableData" class="mat-elevation-z8">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let row"> {{row.id}} </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> Value </th>
        <td mat-cell *matCellDef="let row"> {{row.value}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['id', 'value']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['id', 'value'];"></tr>
    </table>
  </mat-nested-tree-node>
</mat-tree-->
<div *ngFor="let workflow of workflows" class="margin-left-md">
  <h3>
      {{workflow.ID}}
      <span class="cursor-pointer" (click)="toggleShow(workflow)">{{workflow.NAME}}</span>
      <mat-icon class="v-align-middle cursor-pointer" [color]="workflow.SHOW ? 'primary' : ''"
          (click)="toggleShow(workflow)">
          {{workflow.SHOW ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
  </h3>
  <div *ngFor="let state of workflow.states; let i = index" [hidden]="!workflow.SHOW" class="margin-left-md margin-bottom-sm">
					<h2>
            <span style="width: 40px;">{{state.NODES.length}}&nbsp;</span>
            <span class="cursor-pointer" (click)="toggleShow(state);">{{state.DESCRIPTION}}--</span>
             <!--updateDataSource3(state.NODES)--> 
						<!--span class="cursor-pointer" (click)="toggleShow(cur)"> {{'(' + (filter.length
							=== 0 ? '' : tableDataSources[i]?.filteredData?.length + '/') + cur.STUDENTS!.length +
							')'}}</span-->

						<mat-icon class="v-align-middle cursor-pointer" [color]="state.SHOW ? 'primary' : ''"
							(click)="toggleShow(state)">
							{{state.SHOW ? 'expand_more' : 'chevron_right'}}
						</mat-icon>
					</h2>
              <!--div *ngFor="let node of state.NODES;">
                <span>{{node.ID}}</span>|
               <span>{{node.CREATED_DATE | date:'MMM d, y' }}</span>|
               <span *ngIf="node.NODE_COES && node.NODE_COES.length > 0">{{node.NODE_COES[0].CO.RECRUITER_NAME}}</span>|
               <span>{{node.lastestUpdatedDate | date:'MMM d, y' }}</span>| 
               <span *ngIf="node.NODE_REGIONS && node.NODE_REGIONS.length > 0">{{node.NODE_REGIONS[0].REGION.CODE}}</span>|
               <span *ngIf="node.NODE_COES && node.NODE_COES.length > 0">{{node.NODE_COES[0].CO.CURRENT_CITY}}</span>|
               <span *ngIf="node.NODE_COES && node.NODE_COES.length > 0">{{node.NODE_COES[0].CO.COE_NUMBER}}</span>
              </div-->

              <table [hidden]="!state.SHOW">
                <thead>
                  <tr>
                    <td>ID{{workflow.ID}}</td>
                    <td>Created</td>
                    <td *ngIf="workflow.ID != 4 && workflow.ID != 6">Recruiter</td>
                    <td>Updated</td>
                    <td *ngIf="workflow.ID == 4">First Name</td>

                    <td>Region</td>
                    <td *ngIf="workflow.ID == 4">Organization</td>
                    <td *ngIf="workflow.ID != 4 && workflow.ID != 6">Current City</td>
                    <td *ngIf="workflow.ID == 6">Provisional School Name</td>
                    <td *ngIf="workflow.ID != 4">COE#</td>
                  </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let node of state.NODES;">
                      <td>{{node.ID}}</td>
                      <td>{{node.CREATED_DATE | date:'MMM d, y' }}</td>
                      <td *ngIf="workflow.ID != 4 && workflow.ID != 6"><span *ngIf="node.NODE_COES && node.NODE_COES.length > 0">{{node.NODE_COES[0].CO.RECRUITER_NAME}}</span></td>
                      <td>{{node.lastestUpdatedDate | date:'MMM d, y' }}</td>
                      <td *ngIf="workflow.ID == 4">{{ node.NODE_ACCOUNT_REQUESTS.length}}<span *ngIf="node.NODE_ACCOUNT_REQUESTS && node.NODE_ACCOUNT_REQUESTS.length > 0">{{node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.FIRST_NAME}}</span></td>
                      <td><span *ngIf="node.NODE_REGIONS && node.NODE_REGIONS.length > 0">{{node.NODE_REGIONS[0].REGION.CODE}}</span></td>
                      <td *ngIf="workflow.ID != 4 && workflow.ID != 6"><span *ngIf="node.NODE_COES && node.NODE_COES.length > 0">{{node.NODE_COES[0].CO.CURRENT_CITY}}</span></td>
                      <td *ngIf="workflow.ID == 6"><span *ngIf="node.NODE_PROVISIONAL_SCHOOLS && node.NODE_PROVISIONAL_SCHOOLS.length > 0">{{ node.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.SCHOOL_NAME}}</span></td>
                      <td *ngIf="workflow.ID == 4"><span *ngIf="node.NODE_REGIONS && node.NODE_REGIONS.length > 0">{{node.NODE_REGIONS[0].REGION.ORGANIZATION.NAME}}</span></td>
                      <td *ngIf="workflow.ID != 4">
                        <span *ngIf="node.NODE_COES && node.NODE_COES.length > 0">{{node.NODE_COES[0].CO.COE_NUMBER}}</span>
                        <span *ngIf="workflow.ID == 6 && node.NODE_PROVISIONAL_SCHOOLS && node.NODE_PROVISIONAL_SCHOOLS.length > 0">{{node.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.CO.COE_NUMBER}}</span>
                      </td>
                    </tr>
                </tbody>
                </table>

                table data - {{dataSource.length}}

                <div class="mat-elevation-z8" [hidden]="!state.SHOW">
                <app-mat-table-queue [dataSource]="dataSource"></app-mat-table-queue>
                </div>

---
                <!--div class="mat-elevation-z8" [hidden]="!state.SHOW">
                   <table mat-table [dataSource]="dataSource" class="mat-table" matSort
                  (matSortChange)="announceSortChange($event)">
                    <ng-container matColumnDef="ID">
                      <th mat-header-cell *matHeaderCellDef>ID</th>
                      <td mat-cell *matCellDef="let element"> {{element.ID}} </td>
                    </ng-container>
                
                    <ng-container matColumnDef="CREATED_DATE">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>CREATED DATE</th>
                      <td mat-cell *matCellDef="let element"> {{element.CREATED_DATE | date:'MM/dd/yyyy hh:mm a'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="UPDATED_DATE">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>UPDATED DATE</th>
                      <td mat-cell *matCellDef="let element"> {{element.lastestUpdatedDate | date:'MM/dd/yyyy hh:mm a'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="REGION">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>REGION</th>
                      <td mat-cell *matCellDef="let element"> {{element.NODE_REGIONS[0].REGION.CODE}} </td>
                    </ng-container>

                    <ng-container matColumnDef="RECRUITER_NAME">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>RECRUITER</th>
                      <td mat-cell *matCellDef="let element"><span *ngIf="element.NODE_COES && element.NODE_COES.length > 0">{{element.NODE_COES[0].CO.RECRUITER_NAME}}</span></td>
                    </ng-container>

                    <ng-container matColumnDef="ORGANIZATION">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>ORGANIZATION</th>
                      <td mat-cell *matCellDef="let element"><span *ngIf="element.NODE_REGIONS && element.NODE_REGIONS.length > 0">{{element.NODE_REGIONS[0].REGION.ORGANIZATION.NAME}}</span></td>
                    </ng-container>

                    <ng-container matColumnDef="CURRENT_CITY">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>CURRENT CITY</th>
                      <td mat-cell *matCellDef="let element"><span *ngIf="element.NODE_COES && element.NODE_COES.length > 0">{{element.NODE_COES[0].CO.CURRENT_CITY}}</span></td>
                    </ng-container>

                    <ng-container matColumnDef="COE_NUMBER">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>COE#</th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.NODE_COES && element.NODE_COES.length > 0">{{element.NODE_COES[0].CO.COE_NUMBER}}</span>
                        <span *ngIf="workflow.ID == 6 && element.NODE_PROVISIONAL_SCHOOLS && element.NODE_PROVISIONAL_SCHOOLS.length > 0">{{element.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.CO.COE_NUMBER}}</span>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
               
                  <mat-paginator [length]="nodeLength" #searchPaginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                    aria-label="Select page of periodic elements" 
                    >
					</mat-paginator>
                </div-->
                
          <!--table length - {{tableDataSources[i]?.filteredData?.length}}
          <mat-table [dataSource]="tableDataSources[i]" class="mat-elevation-z1" matSort
          [hidden]="tableDataSources[i]?.filteredData?.length === 0">
						<ng-container matColumnDef="CREATED_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Created </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.CREATED_DATE}} </mat-cell>
						</ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
					</mat-table>

					<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
						aria-label="Select page of periodic elements"
						[hidden]="!state.SHOW || tableDataSources[i]?.filteredData?.length === 0">
					</mat-paginator-->
          
          
        </div>
</div>          